import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import { PaymentMethod1x8gg38hdlghq as PaymentMethod } from '../../../../../../crowpay-shared/com/crowpay/paymentModels.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_rawSession1kjo1nj4tz6n0 as get_rawSession } from '../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get_section1qyzr1npzel2z as get_section } from '../../theming/sections.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../theming/Titles.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../components/nav/crowpay.mjs';
import { SetupCustomerMethodDialog2y75086l50hfg as SetupCustomerMethodDialog } from '../../dialogs/SetupCustomerMethodDialog.mjs';
import { EditMethodDialogf2d0knlmpnxu as EditMethodDialog } from '../../dialogs/EditMethodDialog.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  LateInitSignal30crwrg540xyy as LateInitSignal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  forEach37zw770vd3h4l as forEach,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { ActivityIndicatork1oa7i2hevyv as ActivityIndicator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ActivityIndicator.commonHtml.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../theming/buttons.mjs';
import {
  chunked1umgsyuj0x9u1 as chunked,
  first58ocm7j58k3q as first,
  getOrNull1go7ef9ldk0df as getOrNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = $this.lj2_1.oj2($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$SetupCustomerMethodDialog, it, $completion) {
  var tmp = $this.pj2_1.oj2($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var ClientPaymentMethodForm$render$slambda$slambdaClass;
function ClientPaymentMethodForm$render$slambda$slambda() {
  if (ClientPaymentMethodForm$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.pj2_1 = this$0;
      }
      qgx($this$SetupCustomerMethodDialog, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$SetupCustomerMethodDialog, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ViewWriter() ? p1 : THROW_CCE();
        return this.qgx(tmp, p2 instanceof PaymentMethod() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ClientPaymentMethodForm$render$slambda$slambdaClass = $;
  }
  return ClientPaymentMethodForm$render$slambda$slambdaClass;
}
function ClientPaymentMethodForm$render$slambda$slambda_0(this$0) {
  var i = new (ClientPaymentMethodForm$render$slambda$slambda())(this$0);
  var l = ($this$SetupCustomerMethodDialog, it, $completion) => i.qgx($this$SetupCustomerMethodDialog, it, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $this$EditMethodDialog, $completion) {
  var tmp = $this.qj2_1.oj2($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda$slambda_l46vihClass;
function ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda$slambda_l46vih() {
  if (ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda$slambda_l46vihClass === VOID) {
    class $ {
      constructor($this$0) {
        this.qj2_1 = $this$0;
      }
      wgg($this$EditMethodDialog, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$EditMethodDialog), $completion);
      }
      s2(p1, $completion) {
        return this.wgg(p1 instanceof ViewWriter() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda$slambda_l46vihClass = $;
  }
  return ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda$slambda_l46vihClass;
}
function ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda$slambda_l46vih_0($this$0) {
  var i = new (ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda$slambda_l46vih())($this$0);
  var l = ($this$EditMethodDialog, $completion) => i.wgg($this$EditMethodDialog, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_retrievePaymentMethods__3kixcw($this, $completion) {
  $this.nj2_1.saq();
  var tmp = await_0(get_rawSession(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tfw();
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.bfh_1;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = tmp2_safe_receiver.kfs($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var tmp3_elvis_lhs = tmp_0;
  var tmp_2 = $this.nj2_1.gah(tmp3_elvis_lhs == null ? emptyList() : tmp3_elvis_lhs, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod_igk8u9(_this__u8e3s4, this$0, method) {
  var tmp = get_section(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.eba(get_AppDimensions().wg1_1);
  view.zb8(get_AppDimensions().wg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  var tmp0_elvis_lhs_1 = method.k70_1;
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content = tmp0_elvis_lhs_1 == null ? ' ' : tmp0_elvis_lhs_1;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_0 = view_1.tb5_1;
  var tmp_1;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_1 = '\xA0';
  } else {
    tmp_1 = content;
  }
  tmp_0.fbu(tmp_1);
  view_0.fbb(p_1, view_1);
  var tmp1_safe_receiver = method.l70_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.m9l_1;
  body(view_0, tmp2_elvis_lhs == null ? ' ' : tmp2_elvis_lhs);
  var tmp3_safe_receiver = method.l70_1;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.k9l_1;
  body(view_0, '*** *** ' + (tmp4_elvis_lhs == null ? ' ' : tmp4_elvis_lhs));
  view.fbb(p_0, view_0);
  onClick(view, VOID, VOID, ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda_4ntgst_0(method, this$0));
  _this__u8e3s4.fbb(p, view);
  _this__u8e3s4.jbb(tmp, view);
}
var ClientPaymentMethodForm$render$slambdaClass;
function ClientPaymentMethodForm$render$slambda() {
  if (ClientPaymentMethodForm$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.lj2_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ClientPaymentMethodForm$render$slambdaClass = $;
  }
  return ClientPaymentMethodForm$render$slambdaClass;
}
function ClientPaymentMethodForm$render$slambda_0(this$0) {
  var i = new (ClientPaymentMethodForm$render$slambda())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ClientPaymentMethodForm$render$slambdaClass_0;
function ClientPaymentMethodForm$render$slambda_1() {
  if (ClientPaymentMethodForm$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.rj2_1 = this$0;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        tmp.xgd(new (SetupCustomerMethodDialog())(ClientPaymentMethodForm$render$slambda$slambda_0(this.rj2_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ClientPaymentMethodForm$render$slambdaClass_0 = $;
  }
  return ClientPaymentMethodForm$render$slambdaClass_0;
}
function ClientPaymentMethodForm$render$slambda_2(this$0) {
  var i = new (ClientPaymentMethodForm$render$slambda_1())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda_4ntgstClass;
function ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda_4ntgst() {
  if (ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda_4ntgstClass === VOID) {
    class $ {
      constructor($method, $this$0) {
        this.sj2_1 = $method;
        this.tj2_1 = $this$0;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        tmp.xgd(new (EditMethodDialog())(this.sj2_1, ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda$slambda_l46vih_0(this.tj2_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda_4ntgstClass = $;
  }
  return ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda_4ntgstClass;
}
function ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda_4ntgst_0($method, $this$0) {
  var i = new (ClientPaymentMethodForm$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod$slambda_4ntgst())($method, $this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ClientPaymentMethodFormClass;
function ClientPaymentMethodForm() {
  if (ClientPaymentMethodFormClass === VOID) {
    class $ {
      constructor() {
        this.mj2_1 = new (Constant())(_Constant___init__impl__v45mub('Payment Methods'));
        this.nj2_1 = LateInitSignal().raq();
      }
      ucv() {
        return this.mj2_1;
      }
      oj2($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_retrievePaymentMethods__3kixcw.bind(VOID, this), $completion);
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        view.zb8(get_AppDimensions().wg1_1);
        launch(view, VOID, VOID, ClientPaymentMethodForm$render$slambda_0(this));
        sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(40));
        var tmp = get_centered(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.activityIndicator' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (ActivityIndicator())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        var $this$activityIndicator = view_0;
        reactiveScope($this$activityIndicator, ($this$reactiveScope) => {
          $this$activityIndicator.bba(true);
          try {
            $this$reactiveScope.baj(this.nj2_1);
          } catch ($p) {
            if ($p instanceof Exception()) {
              var _unused_var__etf5q3 = $p;
            } else {
              throw $p;
            }
          }
          $this$activityIndicator.hb7(false);
          return Unit_instance;
        });
        view.fbb(p_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.contains' call
        view.jbb(tmp, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_1 = view.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.ebb(p_1, view_1);
        view_1.xbm(true);
        var $this$col = view_1;
        reactiveScope($this$col, ($this$reactiveScope) => {
          $this$col.hb7(false);
          try {
            $this$reactiveScope.baj(this.nj2_1);
          } catch ($p) {
            if ($p instanceof Exception()) {
              var _unused_var__etf5q3 = $p;
            } else {
              throw $p;
            }
          }
          $this$col.bba(true);
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())($this$col.pc());
        var tmp0_elvis_lhs_2 = $this$col.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? $this$col : tmp0_elvis_lhs_2;
        $this$col.ebb(p_2, view_2);
        view_2.xbm(false);
        var tmp_0 = get_expanding(view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Space())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_2.fbb(p_3, view_3);
        view_2.jbb(tmp_0, view_3);
        var tmp_1 = get_tertiaryButton(view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Button())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.ebb(p_4, view_4);
        specCenteredText(view_4, '+ Connect Account');
        onClick(view_4, VOID, VOID, ClientPaymentMethodForm$render$slambda_2(this));
        view_2.fbb(p_4, view_4);
        view_2.jbb(tmp_1, view_4);
        $this$col.fbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())($this$col.pc());
        var tmp0_elvis_lhs_5 = $this$col.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? $this$col : tmp0_elvis_lhs_5;
        $this$col.ebb(p_5, view_5);
        view_5.xbm(true);
        var tmp_2 = remember(VOID, VOID, VOID, ($this$remember) => chunked($this$remember.baj(this.nj2_1), 2));
        forEach(view_5, tmp_2, ($this$forEach, methods) => {
          var method1 = first(methods);
          var method2 = getOrNull(methods, 1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$forEach.pc());
          var tmp0_elvis_lhs = $this$forEach.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
          $this$forEach.ebb(p, view);
          view.xbm(false);
          var tmp = get_expanding(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Frame())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          view_0.eba(get_dp(0));
          view_0.zb8(get_dp(0));
          render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod_igk8u9(view_0, this, method1);
          view.fbb(p_0, view_0);
          view.jbb(tmp, view_0);
          var tmp_0 = get_expanding(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (Frame())(view.pc());
          var tmp0_elvis_lhs_1 = view.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.ebb(p_1, view_1);
          view_1.eba(get_dp(0));
          view_1.zb8(get_dp(0));
          if (method2 == null)
            null;
          else {
            // Inline function 'kotlin.also' call
            render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderMethod_igk8u9(view_1, this, method2);
          }
          view.fbb(p_1, view_1);
          view.jbb(tmp_0, view_1);
          $this$forEach.fbb(p, view);
          return Unit_instance;
        });
        $this$col.fbb(p_5, view_5);
        view.fbb(p_1, view_1);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    initMetadataForClass($, 'ClientPaymentMethodForm', ClientPaymentMethodForm, VOID, [Page()], [0]);
    ClientPaymentMethodFormClass = $;
  }
  return ClientPaymentMethodFormClass;
}
//region block: exports
export {
  ClientPaymentMethodForm as ClientPaymentMethodForm3hm4q2ecszvlb,
};
//endregion

//# sourceMappingURL=ClientPaymentMethodForm.mjs.map
